<template>
  <router-link class="nav-link mr-lg-4" :to="{ name: 'all-messages' }">
    <!-- show icon when >lg -->
    <div v-if="unreadMessagesAll > 0" class="icon-dot">
      <font-awesome-icon icon="circle" size="xs" class="text-success" />
    </div>
    <div class="d-none d-lg-block">
      <div
        id="tooltip-chat-icon"
        class="d-flex justify-content-center align-items-center bg-neutral-success nav__icon-frame box-icon-chat"
      >
        <font-awesome-icon icon="comment" size="lg" class="text-success" />
      </div>
      <b-tooltip target="tooltip-chat-icon" variant="success">
        You have <b>{{ unreadMessagesAll ? unreadMessagesAll : 0 }}</b> unread messages
      </b-tooltip>
    </div>
    <!-- show text when <lg -->
    <div class="d-lg-none">All Messages</div>
  </router-link>
</template>

<script>
import { userInfoMixin } from '@/mixins/userInfoMixin';
import SendbirdUser from '@/models/SendbirdUser';

export default {
  mixins: [userInfoMixin],

  computed: {
    unreadMessagesAll() {
      return SendbirdUser.unreadMessagesAll(this.user.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.box-icon-chat {
  background: #e1e2e7;
  border-radius: 10.4px;
  padding: 10px;
}
.icon-dot {
  position: absolute;
  margin-top: -6px;
  margin-left: -4px;
}
</style>
